import { createColumnHelper } from "@tanstack/react-table"
import { CircleCheckIcon, CircleDashedIcon } from "lucide-react"

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { formatDate } from "@/lib/utils"

import type { CustomerInvitation } from "@boundless/bl-api-client/customer/models"

const columnHelper = createColumnHelper<CustomerInvitation>()

function InvitationStatus({ isConfirmed }: { isConfirmed: boolean }) {
  return (
    <Tooltip>
      <TooltipTrigger>
        {isConfirmed ? (
          <CircleCheckIcon className="text-success h-5 w-5" />
        ) : (
          <CircleDashedIcon className="text-muted/30 h-5 w-5" />
        )}
      </TooltipTrigger>
      <TooltipContent side="right">
        {isConfirmed ? "Confirmed" : "Pending"}
      </TooltipContent>
    </Tooltip>
  )
}

export const customerReferralColumns = [
  columnHelper.accessor("recipient.firstName", {
    header: "First  Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("recipient.lastName", {
    header: "Last Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("recipient.email", {
    header: "Email",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("isConfirmed", {
    header: "Status",
    cell: (info) => <InvitationStatus isConfirmed={info.getValue()} />,
  }),
  columnHelper.accessor("createdAt", {
    header: "Sent",
    cell: (info) => formatDate(info.getValue()),
    sortingFn: "datetime",
  }),
]
